import type { GlobalFeedbackCollectorComponentProps } from '@confluence/global-feedback-collector';

export type FeedbackModalProps = GlobalFeedbackCollectorComponentProps;
export type FeedbackHandler = (options: FeedbackModalProps) => Promise<void>;

export class ContentFeedbackService {
	#feedbackHandler: FeedbackHandler = async () => {};
	#closeHandler: () => void = () => {};

	registerFeedbackHandler(feedbackHandler: FeedbackHandler) {
		this.#feedbackHandler = feedbackHandler;
	}

	registerCloseHandler(closeHandler: () => void) {
		this.#closeHandler = closeHandler;
	}

	// Show Global Feedback Collector with provided options
	// Feedback handler returns deferred Promise that resolves when modal is closed
	showFeedbackCollector(options: FeedbackModalProps) {
		return this.#feedbackHandler(options);
	}

	// Method exposed to bridge API for allowing whiteboards to close feedback modal
	closeFeedbackModal() {
		this.#closeHandler();
	}
}

export const feedbackService = new ContentFeedbackService();
